module.exports = __webpack_public_path__ + "media/images/front/toppage_cc_2-59dae6b5438899e7f1380869ff68ae53.jpg";